import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import CreateLink from './components/CreateLink';
import LinkList from './components/LinkList';
import Analytics from './components/Analytics';
import ProfilePages from './components/ProfilePages';
import CreateProfilePage from './components/CreateProfilePage';
import ProfilePageAnalytics from './components/ProfilePageAnalytics';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import VerifyEmail from './components/auth/VerifyEmail';
import GoogleCallback from './components/auth/GoogleCallback';
import Profile from './components/auth/Profile';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/admin/AdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import UserManagement from './components/admin/UserManagement';
import UserAnalytics from './components/admin/UserAnalytics';
import AdminSettings from './components/admin/AdminSettings';
import SystemHealth from './components/admin/SystemHealth';
import SystemAnalytics from './components/admin/SystemAnalytics';
import SystemSettings from './components/admin/SystemSettings';
import PlanManagement from './components/admin/PlanManagement';
import AuditLog from './components/admin/AuditLog';
import ApiKeyManagement from './components/ApiKeyManagement';
import ApiDocumentation from './components/ApiDocumentation';
import Webhooks from './components/Webhooks';
import Workspaces from './components/Workspaces';
import WorkspaceAccept from './components/WorkspaceAccept';
import Billing from './components/Billing';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import CookieNotice from './components/legal/CookieNotice';
import { Link } from 'react-router-dom';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-ink-50 text-ink-900 font-sans">
          <Navbar />
          <main className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/register" element={<RegisterForm />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } />
              <Route path="/create" element={
                <ProtectedRoute>
                  <CreateLink />
                </ProtectedRoute>
              } />
              <Route path="/links" element={
                <ProtectedRoute>
                  <LinkList />
                </ProtectedRoute>
              } />
              <Route path="/analytics/:shortCode" element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              } />
              <Route path="/profile-pages" element={
                <ProtectedRoute>
                  <ProfilePages />
                </ProtectedRoute>
              } />
              <Route path="/profile-pages/create" element={
                <ProtectedRoute>
                  <CreateProfilePage />
                </ProtectedRoute>
              } />
                                    <Route path="/profile-pages/:id/edit" element={
                        <ProtectedRoute>
                          <CreateProfilePage />
                        </ProtectedRoute>
                      } />
                                    <Route path="/profile-pages/:id/analytics" element={
                <ProtectedRoute>
                  <ProfilePageAnalytics />
                </ProtectedRoute>
              } />
              <Route path="/api-keys" element={
                <ProtectedRoute>
                  <ApiKeyManagement />
                </ProtectedRoute>
              } />
              <Route path="/webhooks" element={
                <ProtectedRoute>
                  <Webhooks />
                </ProtectedRoute>
              } />
              <Route path="/workspaces" element={
                <ProtectedRoute>
                  <Workspaces />
                </ProtectedRoute>
              } />
              <Route path="/workspaces/accept" element={
                <ProtectedRoute>
                  <WorkspaceAccept />
                </ProtectedRoute>
              } />
              <Route path="/api-docs" element={<ApiDocumentation />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/pricing" element={<Billing />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />

              {/* Admin Routes */}
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminDashboard />
                  </AdminLayout>
                </AdminRoute>
              } />
              <Route path="/admin/users" element={
                <AdminRoute>
                  <AdminLayout>
                    <UserManagement />
                  </AdminLayout>
                </AdminRoute>
              } />
              <Route path="/admin/users/:userId/analytics" element={
                <AdminRoute>
                  <AdminLayout>
                    <UserAnalytics />
                  </AdminLayout>
                </AdminRoute>
              } />
                             <Route path="/admin/settings" element={
                 <AdminRoute>
                   <AdminLayout>
                     <SystemSettings />
                   </AdminLayout>
                 </AdminRoute>
               } />
               <Route path="/admin/plans" element={
                 <AdminRoute>
                   <AdminLayout>
                     <PlanManagement />
                   </AdminLayout>
                 </AdminRoute>
               } />
               <Route path="/admin/health" element={
                 <AdminRoute>
                   <AdminLayout>
                     <SystemHealth />
                   </AdminLayout>
                 </AdminRoute>
               } />
               <Route path="/admin/analytics" element={
                 <AdminRoute>
                   <AdminLayout>
                     <SystemAnalytics />
                   </AdminLayout>
                 </AdminRoute>
               } />
               <Route path="/admin/audit-logs" element={
                 <AdminRoute>
                   <AdminLayout>
                     <AuditLog />
                   </AdminLayout>
                 </AdminRoute>
               } />
            </Routes>
          </main>
          <footer className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-6 border-t border-ink-100 flex flex-wrap items-center justify-between gap-2 text-xs text-ink-500">
            <span>© {new Date().getFullYear()} Dynalink</span>
            <span className="flex gap-4">
              <Link to="/pricing" className="hover:text-ink-700">Pricing</Link>
              <Link to="/privacy" className="hover:text-ink-700">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-ink-700">Terms of Service</Link>
            </span>
          </footer>
          <CookieNotice />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
